class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetBtn = this.querySelector(".search__button--reset");
    this.input?.form?.addEventListener("reset", this.onFormReset.bind(this));
    this.input?.addEventListener(
      "input",
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
    this.resetBtn?.addEventListener("click", this.onFormReset.bind(this));
  }
  toggleResetBtn(value) {
    if (!this.resetBtn) return;
    this.resetBtn.classList.toggle("hidden", !value);
  }
  onChange(event) {
    this.toggleResetBtn(event.target.value);
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm() && this.input) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetBtn("");
    }
  }
}
customElements.define("search-form", SearchForm);
